import { TipoParametro } from "../features/data-visualization/reports/models/parametro";
import { EstadosTareaReporte } from "../features/tasks/tarea-reporte";
import { Roles } from "../features/user/user";

export const ESTADO_TAREA_REPORTE: Map<string, string> = new Map([
    [
        EstadosTareaReporte.PEND, 'Pendiente'
    ],
    [
        EstadosTareaReporte.ENEJ, 'En ejecución'
    ],
    [
        EstadosTareaReporte.FINA, 'Finalizado'
    ],
    [
        EstadosTareaReporte.CANC, 'Cancelado'
    ],
    [
        EstadosTareaReporte.FAIL, 'Falló'
    ],
]);


export const TIPO_PARAMETRO: Map<string, string> = new Map([
    [
        TipoParametro.string, 'Alfanumérico'
    ],
    [
        TipoParametro.number, 'Numérico'
    ],
    [
        TipoParametro.date, 'Fecha'
    ],
    [
        TipoParametro.boolean, 'Check'
    ],
]);

export const TIPO_PARAMETRO_LIST: Map<string, string> = new Map([
    [
        TipoParametro.string, 'Alfanumérico'
    ],
    [
        TipoParametro.number, 'Numérico'
    ],
    [
        TipoParametro.date, 'Fecha'
    ],
]);


export const ROLES: Map<string, string> = new Map([
    [
        Roles.user, 'Usuario'
    ],
    [
        Roles.admin, 'Administrador'
    ],
    [
        Roles.specialist, 'Especialista'
    ]
]);

export enum ParameterExceptions {
    SYSTEM_USER = "SYSTEM_USER",
}

// opcional (REPORT, BOARD, FILE_KNOWLEDGE_BANK)
export enum SearchResultTypes {
    REPORT = "REPORT", //Reportes
    BOARD = "BOARD", //Tableros
    FILE_KNOWLEDGE_BANK = "FILE_KNOWLEDGE_BANK" //Archivos de banco de conocimiento
}